/*
 * @Author: mkRui 1102163949@qq.com
 * @Date: 2026-01-22 18:02:41
 * @LastEditors: mkRui 1102163949@qq.com
 * @LastEditTime: 2026-01-26 17:35:31
 * @FilePath: /polordar-explorer/ui/snippets/topBar/ConnectWalletButton.tsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import React from 'react';

import config from 'configs/app';
import { getEnvValue } from 'configs/app/utils';
import useWeb3Wallet from 'lib/web3/useWallet';
import { Button } from 'toolkit/chakra/button';
import IconSvg from 'ui/shared/IconSvg';

const ConnectWalletButtonContent = () => {
  const { connect, isConnected, address, openModal } = useWeb3Wallet({ source: 'Header' });

  const handleClick = React.useCallback(() => {
    if (isConnected) {
      openModal();
    } else {
      connect();
    }
  }, [ isConnected, openModal, connect ]);

  const label = isConnected && address ?
    `${ address.slice(0, 6) }...${ address.slice(-4) }` :
    'Connect Wallet';

  return (
    <Button
      variant="outline"
      size="sm"
      rounded="full"
      marginRight={ 3 }
      onClick={ handleClick }
    >
      { !isConnected && <IconSvg name="wallet" boxSize={ 5 } mr={ 2 }/> }
      { label }
    </Button>
  );
};

const ConnectWalletButton = () => {
  if (!config.features.blockchainInteraction.isEnabled) {
    // eslint-disable-next-line no-console
    console.warn('[ConnectWalletButton] Blockchain interaction disabled.', {
      feature: config.features.blockchainInteraction,
      chain: config.chain,
      rpcUrls: config.chain.rpcUrls,
      env: {
        NEXT_PUBLIC_WALLET_CONNECT_PROJECT_ID: getEnvValue('NEXT_PUBLIC_WALLET_CONNECT_PROJECT_ID'),
        windowEnvs: typeof window !== 'undefined' ? window.__envs : 'undefined',
      },
    });
    return null;
  }

  return <ConnectWalletButtonContent/>;
};

export default ConnectWalletButton;
